<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      <v-btn v-if="fromEventReprotSubmodule" class="mr-2" slot="createNewButton" color="primary" @click="openDialogHandler">{{$t('message.common.new')}}</v-btn>
      <v-container slot="filterForm" grid-list-xl class="pa-0">
        <v-layout class="ma-0">
          <v-col cols="12" lg="2" sm="4" xs="6" class="text-right pt-0 pb-0">
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="getListHandler" @click:append="getListHandler" outlined dense single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right search-hint-padding" id="searchbtn"></v-text-field>
          </v-col>
          <v-btn v-if="!fromEventReprotSubmodule" class="primary ml-2" @click="filterDrawer = !filterDrawer">
            <v-icon class="mr-2">{{ filterDrawer ? 'mdi-filter-minus' : 'mdi-filter-plus' }}</v-icon>
          </v-btn>
        </v-layout>
      </v-container>
    </data-list>
    <v-navigation-drawer v-model="filterDrawer" stateless app temporary height="100vh" right width="25%">
      <v-card elevation="0" class="my-0">
        <v-card-title class="primary">
          <h5 class="white--text"> {{$t('message.deviations.filter')}}</h5>
          <v-spacer></v-spacer>
          <v-btn icon @click="filterObj = {}; getListHandler()">
              <v-icon color="white" class="mr-2">mdi-filter-remove-outline</v-icon>
            </v-btn>
          <v-btn color="primary" fab small dark @click="filterDrawer = false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 80vh; overflow-y: auto;">
          <v-row class="ma-0 my-2">
            <v-col class="pa-1" cols="12">
              <v-autocomplete v-model="filterObj.userid" :items="listOfUsers" outlined dense @change="getListHandler" clearable item-text="fullname" @click:clear="$nextTick(() => filterObj.userid = 0)"
                item-value="id" :label="$t('message.deviations.incharge')" hide-details></v-autocomplete>
            </v-col>
            <v-col class="pa-1" cols="12">
              <v-autocomplete v-model="filterObj.suppliers" :items="listOfFilterSuppliers" outlined dense @change="getListHandler" @keyup="loadSuppliersForFilter('filterSupplier', $event)" clearable item-text="name" @click:clear="$nextTick(() => filterObj.suppliers = '')"
                item-value="id" :label="$t('message.order.supplier')"
                :placeholder="$t('message.deviations.searchForSupplier')" multiple hide-details ref="filterSupplier"></v-autocomplete>
            </v-col>
            <v-col class="pa-1" cols="12">
              <v-autocomplete v-model="filterObj.categories" :items="listOfMeasureCategory" outlined dense @change="getListHandler" clearable item-text="name" @click:clear="$nextTick(() => filterObj.categories = '')"
                item-value="id" :label="$t('message.layout.measureCategory')" multiple hide-details></v-autocomplete>
            </v-col>
            <v-col class="pa-1" cols="12">
              <v-autocomplete v-model="filterObj.status" :items="listOfMeasureStatus" outlined dense @change="getListHandler" clearable item-text="name" @click:clear="$nextTick(() => filterObj.status = '')"
                item-value="id" :label="$t('message.common.status')" multiple hide-details></v-autocomplete>
            </v-col>
            <v-col cols="12" class="pa-1 mt-2 d-flex">
              <v-menu :close-on-content-click="false" v-model="filterObj.deadlineFromMenu" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined hide-details autocomplete="off" readonly v-model="filterObj.deadlineFrom" clearable :label="$t('message.deviations.deadlineFrom')" prepend-icon="mdi-calendar"
                  v-on="on" @click:clear="clearInputs('deadlineFromPicker', 'deadlineFrom')"></v-text-field>
                </template>
                <v-date-picker color="primary" @input="filterObj.deadlineFromMenu = false; filterObj.deadlineFrom = $formatter.formatDate(filterObj.deadlineFromPicker, 'YYYY-MM-DD', 'DD.MM.YYYY')"
                v-model="filterObj.deadlineFromPicker" first-day-of-week='1' :max="filterObj.deadlineToPicker" @change="getListHandler"></v-date-picker>
              </v-menu>
              <v-menu :close-on-content-click="false" v-model="filterObj.deadlineToMenu" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined hide-details autocomplete="off" readonly v-model="filterObj.deadlineTo" clearable :label="$t('message.deviations.deadlineTo')" prepend-icon="mdi-calendar"
                  v-on="on" @click:clear="clearInputs('deadlineToPicker', 'deadlineTo')"></v-text-field>
                </template>
                <v-date-picker color="primary" @input="filterObj.deadlineToMenu = false; filterObj.deadlineTo = $formatter.formatDate(filterObj.deadlineToPicker, 'YYYY-MM-DD', 'DD.MM.YYYY')"
                v-model="filterObj.deadlineToPicker" :min="filterObj.deadlineFromPicker" first-day-of-week='1' @change="getListHandler"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <v-dialog v-model="dialog" max-width="1150px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
    <v-dialog v-model="shareDialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="sendEmailForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.invoice.resendEmail') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mail.emailIds" ref="autoFocus" :rules="$_requiredValidation"
                  :label="$t('message.user.email')"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mail.subject" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.tickets.subject')"></v-text-field>
              </v-row>
              <v-row>
                <v-flex xs12>
                  <label class="subtitle-1">{{ $t('message.tickets.body') }}</label>
                  <ckeditor :editor="editor" v-model="mail.body" :config="configEditor"></ckeditor>
                </v-flex>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareLoading" @click="sendReport">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
import Editor from '@/ckeditor'
import deviationReport from '@/mixins/Deviation/index'
export default {
  data () {
    return {
      filterDrawer: false,
      filterObj: {},
      total: 0,
      listOfMeasureStatus: [],
      listOfMeasureCategory: [],
      listOfDeviations: [],
      dialog: false,
      search: '',
      modelObj: { isactive: true },
      listOfSuppliers: [],
      listOfFilterSuppliers: [],
      listPayloadObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        hasFilters: true,
        headers: [],
        list: [],
        loading: false,
        editProp: 'title',
        editProp1: 'deviation_title',
        editURL1: (item) => `/deviations/actions/${item.deviationid}`,
        editHandler: this.getSingleRecordHandler,
        actionsList: [{
          click: (item) => this.shareMeasures(item),
          icon: () => 'mdi-email-variant',
          is_show: (item) => item.type !== 'sales'
        }]
      },
      loading: false,
      fromEventReprotSubmodule: Boolean(this.$route.path.startsWith('/deviations')),
      pagination: !this.$formatter.isEmptyObject(this.$store.state.DEVIATION_MEASURE_INDEX) ? this.$store.state.DEVIATION_MEASURE_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'deviationmeasures',
      shareDialog: false,
      mail: {
        subject: '',
        body: ''
      },
      editor: Editor,
      shareLoading: false,
      configEditor: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      }
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  mixins: [deviationReport],
  computed: {
    headers () {
      const headers = [{
        text: this.$t('message.deviations.title'),
        value: 'title',
        showAlways: true
      }, {
        text: this.$t('message.deviations.incharge'),
        value: 'inchargeuser_name'
      }, {
        text: this.$t('message.layout.measureCategory'),
        value: 'measure_category_name'
      }, {
        text: this.$t('message.common.status'),
        value: 'status_name'
      }, {
        text: this.$t('message.order.supplier'),
        value: 'supplier_name'
      }, {
        text: this.$t('message.customer.description'),
        value: 'description'
      }, {
        text: this.$t('message.deviations.date'),
        value: 'date'
      }, {
        text: this.$t('message.deviations.deadline'),
        value: 'deadline'
      }]
      if (!this.fromEventReprotSubmodule) {
        headers.push({
          text: this.$t('message.layout.deviation'),
          value: 'deviation_title'
        })
      }
      headers.push({
        text: '',
        sortable: false,
        value: 'actions'
      })
      return headers
    },
    ...mapState(['FORM_TYPE', 'listOfUsers']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.deviations.updateMeasures') : this.$t('message.deviations.addMeasures'),
        properties: [{
          model: 'deviation_title',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.layout.deviation'),
          items: this.listOfDeviations,
          select_text: (val) => `${val.name || ''}`,
          select_value: 'id',
          disabled: true,
          class: 'xs12',
          is_hide: Boolean(this.fromEventReprotSubmodule)
        }, {
          model: 'title',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.deviations.title'),
          disabled: false,
          class: 'xs8',
          change: this.recordModified
        }, {
          model: 'measurecategoryid',
          type: this.FORM_TYPE.SELECT,
          items: this.listOfMeasureCategory,
          select_text: 'name',
          select_value: 'id',
          rules: [],
          label: this.$t('message.layout.measureCategory'),
          disabled: false,
          class: 'xs4',
          change: this.recordModified
        }, {
          model: 'inchargeuserid',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.deviations.incharge'),
          items: this.listOfUsers,
          select_text: 'fullname',
          select_value: 'id',
          class: 'md3 sm6',
          change: this.recordModified
        }, {
          model: 'date',
          type: this.FORM_TYPE.DATEPICKER,
          label: this.$t('message.deviations.date'),
          class: 'md3 sm6',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          change: this.recordModified
        }, {
          model: 'deadline',
          type: this.FORM_TYPE.DATEPICKER,
          label: this.$t('message.deviations.deadline'),
          class: 'md3 sm6',
          picker: 'deadlinePicker',
          menu: 'deadlineMenu',
          color: 'primary lighten-1',
          change: this.recordModified
        }, {
          model: 'status',
          type: this.FORM_TYPE.SELECT,
          items: this.listOfMeasureStatus,
          select_text: 'name',
          select_value: 'id',
          rules: [],
          label: this.$t('message.common.status'),
          disabled: false,
          class: 'md3 sm6',
          change: this.recordModified
        }, {
          model: 'supplierid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfSuppliers,
          select_text: 'name',
          select_value: 'id',
          term: 'searchSupplier',
          placeholder: this.$t('message.deviations.searchForSupplier'),
          keyup: this.loadSuppliers,
          rules: [],
          label: this.$t('message.order.supplier'),
          disabled: false,
          class: 'xs6',
          change: this.recordModified
        }, {
          model: 'estimatedinternalcost',
          type: this.FORM_TYPE.NUMBER,
          rules: [],
          label: this.$t('message.deviations.estimatedInternalCost'),
          class: 'xs3',
          change: this.changesMade
        }, {
          model: 'estimatedcustomercost',
          type: this.FORM_TYPE.NUMBER,
          rules: [],
          label: this.$t('message.deviations.estimatedCustomerCost'),
          class: 'xs3',
          change: this.changesMade
        }, {
          model: 'description',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          rows: 3,
          label: this.$t('message.customer.description'),
          class: 'xs12 md6',
          change: this.recordModified
        }, {
          model: 'actions',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.tickets.actions'),
          class: 'xs12 md6',
          rows: 3,
          change: this.recordModified
        }, {
          model: 'reason',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.reason'),
          class: 'xs12 md6',
          rows: 3,
          change: this.recordModified
        }, {
          model: 'underlying_reason',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.underlying_reason'),
          class: 'xs12 md6',
          rows: 3,
          change: this.recordModified
        }, {
          model: 'corrective_actions',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.corrective_actions'),
          class: 'xs12 md6',
          rows: 3,
          change: this.recordModified
        }, {
          model: 'effective_of_measures',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.effective_of_measures'),
          class: 'xs12 md6',
          rows: 3,
          change: this.recordModified
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: this.modelObj.id ? 'edit' : 'add'
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        const model = { type: 'DEVIATION_MEASURE_INDEX', data: val }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    },
    search (val) {
      if (!val) {
        this.getListHandler()
      }
    },
    'modelObj.deadlinePicker' (val) {
      if (val) {
        this.modelObj.deadline = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'modelObj.datePicker' (val) {
      if (val) {
        this.modelObj.date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  mounted () {
    this.$store.dispatch('getUsers')
    this.getStatusList()
    this.getDeviationMeasureStatusList()
    const text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    const queryParam = this.$route.query
    if (queryParam && +queryParam.openmeasure) {
      this.getSingleRecordHandler(+queryParam.openmeasure)
    }
  },
  methods: {
    getStatusList () {
      return this.$_executeApi('get', 'measurestatuslists').then(({ data }) => {
        this.listOfMeasureStatus = data
      })
    },
    getDeviationMeasureStatusList () {
      return this.$_executeApi('get', 'deviationmeasurecategories').then(({ data }) => {
        this.listOfMeasureCategory = data
      })
    },
    async shareMeasures (payload) {
      this.getInvoiceSettings()
        .then(() => {
          const { mail_signature: mailSign } = this.$formatter.cloneVariable(this.settingsObj)
          this.shareDialog = true
          const deviationPath = `${process.env.VUE_APP_WEB}/deviation_measures?openmeasure=${payload.id}`
          const defaultText = `For detaljer om tiltaket klikk <a href='${deviationPath}'>HER</a> <br />`
          this.mail.body = `${defaultText} <br /> ${mailSign}`
          this.mail.measureTitle = payload.title || ''
          this.mail.deviationId = payload.deviationid
          this.mail.measureId = payload.id || 0
          this.mail.subject = `Avvikstiltak: ${payload.title || ''}`
        })
    },
    getInvoiceSettings () {
      return this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    closeShareDialog () {
      this.mail = {}
      this.shareDialog = false
    },
    async sendReport () {
      if (this.$refs.sendEmailForm.validate()) {
        let isValidEmail = false
        if (!this.mail.emailIds.length > 0) isValidEmail = true
        let getMailIDsString = this.mail.emailIds
        let listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              this.validEmail(listOfMailIds[i]) ? isValidEmail = false : isValidEmail = true
            }
          }
        }
        const model = {}
        if (!isValidEmail) {
          this.shareLoading = true
          model.to = listOfMailIds
          model.subject = this.mail.subject
          model.body = this.mail.body
          model.ids = [this.mail.deviationId]
          model.filesendType = 1
          var content = await this.genereateReportContent([this.mail.measureId], true, this.mail.measureTitle)
          model.pdfcontent = { content }
          this.$_executeApi('post', 'deviations/share', model).then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
            this.mail = {}
            this.shareDialog = false
          }).finally(() => {
            this.shareLoading = false
          })
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
    },
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      const { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const model = {
        descending: sortDesc[0],
        page: page,
        rowsperpage: itemsPerPage,
        sortby: sortBy[0],
        search: this.search,
        userid: this.filterObj.userid || 0,
        categories: this.filterObj.categories || '',
        status: this.filterObj.status || '',
        suppliers: this.filterObj.suppliers || '',
        deadlinefrom: this.$formatter.formatDate(this.filterObj.deadlineFrom, 'DD.MM.YYYY', 'YYYY-MM-DD'),
        deadlineto: this.$formatter.formatDate(this.filterObj.deadlineTo, 'DD.MM.YYYY', 'YYYY-MM-DD')
      }
      if (this.fromEventReprotSubmodule) {
        model.deviationid = Number(this.$route.params.deviation_id)
      }
      this.$_executeApi('post', `${this.MODULE}/paginate_filter`, model).then(response => {
        const { items, total } = response.data
        const transformData = { date: { list: ['deadline', 'date'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
        const model = this.$_formatListModel(items, transformData)
        this.listPayloadObj.list = model
        this.total = total
      }).finally(() => {
        this.listPayloadObj.loading = false
      })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE}/${id}`).then(({ data }) => {
        const transformData = { date: { list: ['deadline', 'date'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
        const model = this.$formatter.formatModel(data, transformData)
        if (data && data.deviation_title) {
          this.listOfDeviations = [{ name: data.deviation_title, id: data.deviationid }]
          if (data.supplierid) this.listOfSuppliers = [{ name: data.supplier_name, id: data.supplierid }]
          model.deviation_title = data.deviationid
        }
        this.modelObj = model
        this.dialog = true
      })
    },
    openDialogHandler () {
      const defaultStatus = this.listOfMeasureStatus.find(x => x.isdefault)
      if (defaultStatus != null) {
        this.modelObj.status = defaultStatus.id
      }
      this.modelObj.isactive = true
      this.dialog = true
    },
    clearInputs (picker, model) {
      this.$nextTick(() => {
        this.filterObj[picker] = null
        this.filterObj[model] = null
        this.getListHandler()
      })
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        const transformData = { date: { list: ['deadline', 'date'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DD' } }
        const model = this.$formatter.formatModel(this.modelObj, transformData)
        model.deviationid = this.$route.params.deviation_id
        if (!model.estimatedinternalcost) model.estimatedinternalcost = 0
        if (!model.estimatedcustomercost) model.estimatedcustomercost = 0
        const url = this.MODULE
        this.$_saveUpdateHandler(url, model).then((response) => {
          this.closeDialogHandler()
          this.getListHandler()
        }).finally(() => { this.loading = false })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    // Searching suppliers
    async loadSuppliers (term, event) {
      if ([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs.fieldsReference.$refs[term][0].lazySearch
      const list = await this.supplierFilter(searchText)
      if (!this.listOfSuppliers) this.listOfSuppliers = []
      this.listOfSuppliers = list
    },
    async loadSuppliersForFilter (term, event) {
      if ([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term].lazySearch
      const list = await this.supplierFilter(searchText)
      if (!this.listOfFilterSuppliers) this.listOfFilterSuppliers = []
      this.listOfFilterSuppliers = list
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    supplierFilter(searchText) {
      return new Promise((resolve, reject) => {
        let model = {
          'filter': `name contains '${searchText}'`,
          'additionalfilters': [`isactive eq 1 AND issupplier eq 1`],
          'order_by': {
            'field': 'name',
            'asc_or_desc': 'asc'
          },
          'skip': 0,
          'limit': 50
        }
        this.$_executeApi('post', 'customers/query', model)
          .then((response) => {

            this.listOfFilterSuppliers = response.data
            resolve(response.data)
          })
          .catch(() => {
            resolve([])
          })
      })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
